import { FunctionComponent } from "react";

import moment from "moment-timezone";

import { AutoComplete } from "@/components/AutoComplete/AutoComplete";

import { Schedule, ScheduleItem } from "./Schedule";

const DAYS = [
	"monday",
	"tuesday",
	"wednesday",
	"thursday",
	"friday",
	"saturday",
	"sunday",
] as const;

/**
 * Timezone picker + the per-day send-window schedule for a campaign. Shared by the create-campaign
 * modal (and reusable by edit) so the schedule control stays in lockstep.
 */
export const CampaignScheduleFields: FunctionComponent<{
	timezone: string;
	setTimezone: (timezone: string) => void;
	schedule: Schedule;
	setSchedule: (schedule: Schedule) => void;
	timezoneError?: boolean;
	scheduleError?: string;
}> = ({ timezone, setTimezone, schedule, setSchedule, timezoneError, scheduleError }) => (
	<div className="flex flex-col gap-4">
		<AutoComplete
			data={moment.tz.names().map((tz) => ({ id: tz, title: tz }))}
			error={timezoneError}
			floating={true}
			handleReset={() => setTimezone("")}
			handleSearch={() => {}}
			handleSelect={(value) => setTimezone(value?.title || "")}
			label="Timezone"
			selectedItem={timezone || ""}
		/>

		<div className="flex flex-col gap-2 mt-4">
			{DAYS.map((day) => (
				<ScheduleItem
					key={day}
					day={day}
					error={!!scheduleError}
					schedule={schedule}
					setSchedule={setSchedule}
				/>
			))}

			{scheduleError && <div className="text-status-error text-sm">{scheduleError}</div>}
		</div>
	</div>
);
